export const rootPath = '/tenant';

export const devicePath = '/device';
export const subscriptionPath = '/subscription';
export const satellitePath = '/satellite';

export const viewPath = `${rootPath}/view`;
export const createPath = `${rootPath}/create`;
export const movePath = `${rootPath}/move`;
export const linksPath = '/links';
export const historyPath = '/history';
export const ticketsPath = '/tickets';
export const satelliteSearchPath = `${rootPath}${satellitePath}`;
export const deviceSearchPath = `${rootPath}${devicePath}`;
export const deviceHelpPath = `${rootPath}${devicePath}/help`;

export function getTenantPath(tenantId) {
  return `${viewPath}/${tenantId}`;
}

export function getTenantDevicesPath(tenantId) {
  return `${getTenantPath(tenantId)}${devicePath}`;
}

export function getTenantMacPath(tenantId, macId) {
  return `${getTenantDevicesPath(tenantId)}?id=${macId}`;
}

export function getSubscriptionPath(tenantId) {
  return `${getTenantPath(tenantId)}${subscriptionPath}`;
}

export function getTenantReceiverPath(tenantId) {
  return `${getTenantPath(tenantId)}${satellitePath}`;
}

export function getTenantHistoryPath(tenantId) {
  return `${getTenantPath(tenantId)}${historyPath}`;
}

export function getTenantTicketsPath(tenantId) {
  return `${getTenantPath(tenantId)}${ticketsPath}`;
}

export function getTenantLinksPath(tenantId) {
  return `${getTenantPath(tenantId)}${linksPath}`;
}

export function getTenantCreatePath(buildingId, unitId) {
  const searchParams = new URLSearchParams();
  if (buildingId) searchParams.set('building_id', buildingId);
  if (unitId) searchParams.set('unit_id', unitId);
  return `${createPath}?${searchParams.toString()}`;
}
export function getTenantMovePath(buildingId, unitId, tenantId) {
  const searchParams = new URLSearchParams();
  if (buildingId) searchParams.set('building_id', buildingId);
  if (unitId) searchParams.set('unit_id', unitId);
  if (tenantId) searchParams.set('tenant_id', tenantId);
  return `${movePath}?${searchParams.toString()}`;
}
